<div class="cabboton container p-3 my-3 bg-cabimp text-white">
    <button  class="btn btn-cave" (click)="volver()">
      <fa-icon [icon]="icoRet"></fa-icon>  Volver
    </button>
     <button style="margin-left:5px;" class="btn btn-success"  onClick="window.print()">
      <fa-icon [icon]="icoPrn"></fa-icon>  Imprimir
    </button>
</div>
<div style="text-align: center;">
  <div *ngIf="resul" class="spinner-border text-primary" role="status"></div>
</div>

<div class="cuerpo">
   <h2 class="heading" style="text-align: center;">LIQUIDACIONES </h2>
   <h3 class="heading" style="text-align: center;">{{nomusu}} </h3>

   <table id="tabla" class="table table-bordered row-border hover">
           <thead>
             <tr>
               <th >Fecha</th>
               <th >Liquidación</th>
               <th >Hectógrados</th>
               <th >Importes</th>
               <th >I.V.A.</th>
               <th >Anticipos</th>
               <th >Capital</th>
               <th >Exceso @/pH</th>
               <th >Compras</th>
               <th >Retenciones</th>
               <th >Total Neto</th>
             </tr>
           </thead> 
           <tbody>
             <tr *ngFor="let dato of datosTabla"> 
               <td [ngClass]="{'stotal': dato.liqFech === 'TOTALES'}">{{ dato.liqFech }}</td>
               <td *ngIf="dato.liqLiqu > 0" [ngClass]="{'stotal': dato.liqFech === 'TOTALES'}" class="numero">{{ dato.liqLiqu }}</td> 
               <td *ngIf="dato.liqLiqu === 0" >  </td> 
               <td [ngClass]="{'stotal': dato.liqFech === 'TOTALES'}" class="numero">{{ dato.liqHect | number: '.4'}}</td>
               <td [ngClass]="{'stotal': dato.liqFech === 'TOTALES'}" class="numero">{{ dato.liqImpo | number: '.2'}}</td>
               <td [ngClass]="{'stotal': dato.liqFech === 'TOTALES'}" class="numero">{{ dato.liqIvas | number: '.2'}}</td>
               <td [ngClass]="{'stotal': dato.liqFech === 'TOTALES'}" class="numero">{{ dato.liqAnti | number: '.2'}}</td>
               <td [ngClass]="{'stotal': dato.liqFech === 'TOTALES'}" class="numero">{{ dato.liqAnua | number: '.2'}}</td>
               <td [ngClass]="{'stotal': dato.liqFech === 'TOTALES'}" class="numero">{{ dato.liqExce | number: '.2'}}</td>
               <td [ngClass]="{'stotal': dato.liqFech === 'TOTALES'}" class="numero">{{ dato.liqVtas | number: '.2'}}</td>
               <td [ngClass]="{'stotal': dato.liqFech === 'TOTALES'}" class="numero">{{ dato.liqRete | number: '.2'}}</td>
               <td [ngClass]="{'stotal': dato.liqFech === 'TOTALES'}" class="numero">{{ dato.liqNeto | number: '.2'}}</td> 
             </tr> 
           </tbody> 
   </table>
 
</div>

 
